(function () {
  // The Switas app-download modal (GTM) waits for this element to disappear before opening.
  function releaseAppModal() {
    var marker = document.getElementById('ucookie-container');
    if (marker) marker.remove();
  }

  function privacyApiReady() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!privacy && typeof privacy.currentVisitorConsent === 'function' && typeof privacy.setTrackingConsent === 'function';
  }

  // Shopify creates customerPrivacy as an empty stub first and adds the methods later.
  function whenPrivacyApiReady(callback) {
    var done = false;
    function finish() {
      if (done || !privacyApiReady()) return;
      done = true;
      callback();
    }
    finish();
    if (done) return;
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      finish();
      if (done || attempts > 300) {
        clearInterval(timer);
        if (!done) releaseAppModal();
      }
    }, 100);
  }

  whenPrivacyApiReady(function () {
    var privacy = window.Shopify.customerPrivacy;
    var bar = document.getElementById('cookie-consent-banner');
    var modal = document.getElementById('cookie-consent-modal');
    if (!bar || !modal) {
      releaseAppModal();
      return;
    }

    var toggles = {
      analytics: document.getElementById('cookie-consent-analytics'),
      marketing: document.getElementById('cookie-consent-marketing'),
      preferences: document.getElementById('cookie-consent-preferences')
    };

    // Clarity is loaded by GTM; tell it the analytics/marketing choice and let GTM tags react too.
    function applyConsentToTags() {
      var consent = privacy.currentVisitorConsent();
      var state = function (key) { return consent[key] === 'yes' ? 'granted' : 'denied'; };
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('consentv2', { ad_Storage: state('marketing'), analytics_Storage: state('analytics') });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cookie_consent_update',
        cookie_consent_analytics: state('analytics'),
        cookie_consent_marketing: state('marketing'),
        cookie_consent_preferences: state('preferences')
      });
    }

    function isUndecided() {
      var consent = privacy.currentVisitorConsent();
      return !consent.analytics && !consent.marketing && !consent.preferences;
    }

    function syncTogglesFromConsent() {
      var consent = privacy.currentVisitorConsent();
      Object.keys(toggles).forEach(function (key) {
        if (toggles[key]) toggles[key].checked = consent[key] === 'yes';
      });
    }

    function hideBanner() {
      bar.hidden = true;
    }

    function openModal() {
      syncTogglesFromConsent();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
    }

    // Close right away; the save is a network call that can take a few seconds.
    function saveConsent(consent) {
      releaseAppModal();
      hideBanner();
      closeModal();
      privacy.setTrackingConsent(consent, applyConsentToTags);
    }

    document.querySelectorAll('[data-cookie-accept-all]').forEach(function (el) {
      el.addEventListener('click', function () {
        saveConsent({ analytics: true, marketing: true, preferences: true });
      });
    });

    document.querySelectorAll('[data-cookie-reject-all]').forEach(function (el) {
      el.addEventListener('click', function () {
        saveConsent({ analytics: false, marketing: false, preferences: false });
      });
    });

    document.querySelectorAll('[data-cookie-open-settings]').forEach(function (el) {
      el.addEventListener('click', openModal);
    });

    document.querySelectorAll('[data-cookie-close-settings]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.querySelectorAll('[data-cookie-save-preferences]').forEach(function (el) {
      el.addEventListener('click', function () {
        saveConsent({
          analytics: !!(toggles.analytics && toggles.analytics.checked),
          marketing: !!(toggles.marketing && toggles.marketing.checked),
          preferences: !!(toggles.preferences && toggles.preferences.checked)
        });
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    applyConsentToTags();

    if (isUndecided()) {
      bar.hidden = false;
    } else {
      releaseAppModal();
    }
  });
})();
